export default __webpack_public_path__ + "static/media/hammer.6a3703e0.webm";